import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { LeaveType } from '../models/LeaveType'
import { LeaveTypeForm } from '../forms/LeaveTypeForm'
import { LeaveTypeFilter } from '../filters/LeaveTypeFilter'
import { LeaveTypeService } from '../services/LeaveTypeService'

export const useLeaveTypeStore: KsStoreHook<LeaveType, LeaveTypeForm, LeaveTypeFilter> = createKsStore({
  id: 'leaveTypes',
  modelClass: LeaveType,
  formClass: LeaveTypeForm,
  filterClass: LeaveTypeFilter,
  service: LeaveTypeService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Type #${item.id}`,
  signalREventName: 'LeaveTypeModel',
  isReferential: true
})
